import * as moment from 'moment';
import * as actions from './calendar.actions';
import { DayModel } from './models/day.model';

export interface State {
    dates: Array<DayModel>;
    loading: boolean;
    startDate: moment.Moment;
}

export const initialState: State = {
    dates: [],
    loading: false,
    startDate: moment()
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {

    switch (action.type) {
        case actions.INIT_SUCCESS: {
            return {
                ...state,
                startDate: action.payload.startDate.clone(),
                dates: action.payload.dates
            };
        }
        case actions.SET_LOADING: {
            return {
                ...state,
                loading: action.payload.loading
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/job-calendar/calendar.reducer.ts